import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_SUPERVISORS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/supervisors/new")({
  component: () => <DeptContentForm cfg={CFRD_SUPERVISORS} />,
});
